import qs from 'qs';

export class EmailNotificationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async sendEmailWithFile({ applicationId, payload }) {
    return this.#http.post(`/application/${applicationId}/email/v2`, payload);
  }

  async sendContactEmail({ contactId, payload }) {
    return this.#http.post(`/contact/${contactId}/email/v2`, payload);
  }

  async getFullEmails(params) {
    return this.#http.get('/EmailNotification/byIds', { params });
  }

  async getEmailActions({ applicationId, emailId }) {
    return this.#http.get(`/application/${applicationId}/email/actions`, {
      params: { emailId: encodeURIComponent(emailId) },
      paramsSerializer: params => qs.stringify(params, { encode: false }),
    });
  }
}
